import React, {useState} from "react";
import PropTypes from "prop-types";
import {FIELD_TYPE_LABELS, detectFieldType} from "./adminUpdateUtils";

const searchInputStyle = {
    height: "45px",
    borderRadius: "8px",
    border: "2px solid #dcdcdc",
    padding: "0 0 0 5px",
    margin: "0",
    boxSizing: "border-box",
    boxShadow: "none",
    width: "100%",
    outline: "none"
};

export const primaryButtonStyle = {
    height: "45px",
    width: "140px",
    borderRadius: "8px",
    fontSize: "15px",
    backgroundColor: "#007935",
    color: "#fff",
    fontWeight: "600",
    border: "none",
    margin: "0",
    padding: "0",
    boxSizing: "border-box",
    flexShrink: 0
};

const LookupStatus = ({lookupError, formatError, lookUpResponse, lookupData}) => {
    if (lookupError?.fieldType) {
        return <div className="text-danger mt-1">{lookupError.fieldType}</div>;
    }

    if (formatError || !lookUpResponse?.data) {
        return null;
    }

    const label = FIELD_TYPE_LABELS[lookupData.fieldType] || lookupData.fieldType;
    return (
        <div className="text-success mb-2">
            Record search by {label}: {lookupData.searchValue}
        </div>
    );
};

LookupStatus.propTypes = {
    lookupError: PropTypes.object,
    formatError: PropTypes.string.isRequired,
    lookUpResponse: PropTypes.object,
    lookupData: PropTypes.object.isRequired
};

LookupStatus.defaultProps = {
    lookupError: null,
    lookUpResponse: null
};

const LookupSearch = ({lookupData, setLookupData, lookupError, lookingUp, handleLookup, lookUpResponse, setLookUpResponse}) => {
    const [formatError, setFormatError] = useState("");
    const isSearchValueValid = Boolean(detectFieldType(lookupData.searchValue));

    const handleSearchValueChange = (e) => {
        const value = e.target.value;
        const detected = detectFieldType(value);

        setFormatError(value.trim() && !detected
            ? "Please enter a valid Email, Phone Number, or Loyalty ID."
            : "");

        setLookupData((oldLookupData) => ({
            ...oldLookupData,
            searchValue: value,
            fieldType: detected || oldLookupData.fieldType
        }));

        setLookUpResponse(null);
    };

    return (
        <>
            <div className="text-center m-6-auto section-title">
                <h4>Find Account Information</h4>
            </div>

            <div style={{display: "flex", alignItems: "flex-start", gap: "15px", width: "100%"}}>
                <div style={{flex: 1}}>
                    <input type="text"
                           name="searchValue"
                           onChange={handleSearchValueChange}
                           className="form-control"
                           placeholder="Enter Email, Loyalty ID or Phone Number"
                           id="searchValue"
                           style={searchInputStyle}/>

                    <div className="text-danger mt-1">
                        {lookupError?.searchValue || formatError}
                    </div>
                </div>

                {isSearchValueValid && (
                    <button id="sub_btn"
                            type="submit"
                            disabled={lookingUp}
                            onClick={handleLookup}
                            style={primaryButtonStyle}>
                        Look-Up
                        {lookingUp && <i className="fa fa-spinner fa-spin ms-2"/>}
                    </button>
                )}
            </div>

            <LookupStatus lookupError={lookupError}
                          formatError={formatError}
                          lookUpResponse={lookUpResponse}
                          lookupData={lookupData}/>
        </>
    );
};

LookupSearch.propTypes = {
    lookupData: PropTypes.shape({
        fieldType: PropTypes.string,
        searchValue: PropTypes.string
    }).isRequired,
    setLookupData: PropTypes.func.isRequired,
    lookupError: PropTypes.object,
    lookingUp: PropTypes.bool,
    handleLookup: PropTypes.func,
    lookUpResponse: PropTypes.object,
    setLookUpResponse: PropTypes.func.isRequired
};

LookupSearch.defaultProps = {
    lookupError: null,
    lookingUp: false,
    handleLookup: undefined,
    lookUpResponse: null
};

export default LookupSearch;
